if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.laravelApiWebServer = api.luxo.createService({
          base_url: 'https://lapi.luxoliving.com.au',
          headers: [
            {
              name: 'Content-Type',
              value: 'application/json'
            }
          ]
        });
        this.apiWebServer = api.luxo.createService({
          base_url: 'https://app.luxoliving.com.au',
          headers: [
            {
              name: 'Content-Type',
              value: 'application/x-www-form-urlencoded'
            }
          ]
        });
      }

      connectedCallback() {
        // this.getLastVisitedCollection();
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        // On Media Gallery Loaded, change the media position
        subscribe(PUB_SUB_EVENTS.mediaGalleryLoaded, (mediaGallery) => {
          this.mediaGallery = mediaGallery;
        });

        const variantSelectors = this.querySelector('variant-selects');
        this.usingVariantSelectors = variantSelectors ? true : false;

        this.initQuantityHandlers();
        const script = this.querySelector('script[type="application/json"][data-product-metadata]');
        if (script) {
          const { product, selected_or_first_available_variant, variant_extra_data, metafields, translations, settings } = JSON.parse(script.textContent);
          this.product = product;
          // Adding Inventory Levels to Variants
          this.product.variants.forEach(variant => {
            // Find the inventory details for the current variant
            const foundVariant = variant_extra_data.find(v => v.id === variant.id);

            // If inventory details exist, add the inventory_quantity property to the variant
            if (foundVariant) {
              variant.inventory_quantity = foundVariant.inventory_quantity;
              variant.metafields = foundVariant.metafields;
              variant.images = foundVariant.images;
            } else {
              // Optionally set a default value if no matching inventory is found
              variant.inventory_quantity = 0;
              variant.metafields = {};
              variant.images = [];
            }
          });
          this.selectedVariant = selected_or_first_available_variant;
          const selectedVariantExtraData = variant_extra_data.find(v => v.id === this.selectedVariant.id) || {};
          this.selectedVariant.inventory_quantity = selectedVariantExtraData.inventory_quantity || 0;
          this.selectedVariant.metafields = selectedVariantExtraData.metafields || {};
          this.selectedVariant.images = selectedVariantExtraData.images || [];
          this.product.metafields = metafields.custom;
          this.metafieldColourOptions = metafields.colour_options;
          this.bundledProducts = metafields.bundled_products;
          this.translations = translations;
          this.settings = settings;

          this.addToCartButton = this.querySelector('.product-form__submit.button');
          this.buyNowButton = this.querySelector('.shopify-payment-button');
          this.product.warehouseLocation = 'WP';

          this.activeCouponPromo = JSON.parse(this.querySelector('coupon-badge')?.dataset.couponPromo || null);
          this.updateProductBadges(this.product);
          if (this.product.available) {
            this.initShippingCalculator(this.product);
            this.displayPromiseDates();
          } else {
            // Show Sold Out Stock Status
            const stockStatusDisplayAll = this.querySelectorAll('.stock-status__display');
            stockStatusDisplayAll.forEach(display => {
              display.innerHTML = `<span class="stock-status__sold-out" data-stock-status="sold-out">
                ${this.translations.stock_status.sold_out}
              </span>`;
            });
          }
        }
        // On Add To Cart, update the added to cart icon
        this.cartUpdateSubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const quantity = event.cartData.quantity;
          this.updateProductQtyInCart(quantity);
        });
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        // Disabling Sticky Add To Cart on scroll for now and making it sticky always
        // this.initStickyAddToCart()
      }

      getLastVisitedCollection() {
        const collectionHandle = sessionStorage.getItem('last_collection_handle');
        const collectionUrl = sessionStorage.getItem('last_collection_url');
        const collectionTitle = sessionStorage.getItem('last_collection_title');

        console.log('Last Visited Collection:', {
          handle: collectionHandle,
          url: collectionUrl,
          title: collectionTitle
        });

        if (collectionHandle && collectionUrl && collectionTitle) {
          const breadcrumbList = document.querySelector('.breadcrumbs ol');
          const activeItem = breadcrumbList.querySelector('.active-page');

          const li = document.createElement('li');
          li.className = 'breadcrumb';
          li.setAttribute('itemprop', 'itemListElement');
          li.setAttribute('itemscope', '');
          li.setAttribute('itemtype', 'http://schema.org/ListItem');

          li.innerHTML = `
            <a href="${collectionUrl}" title="${collectionTitle}" itemprop="item">
              <span itemprop="name">${collectionTitle}</span>
            </a>
          `;

          // Insert before product breadcrumb
          breadcrumbList.insertBefore(li, activeItem);
        }
      }
      initStickyAddToCart() {
        const btnContainer = this.querySelector('.product-form__buttons');
        const body = document.body;

        if (!btnContainer) return;

        const btnContainerDocumentOffset = btnContainer.offsetTop + btnContainer.offsetHeight + 200;

        document.addEventListener("scroll", () => {
          const scrollPosition = window.scrollY + window.innerHeight;

          if (scrollPosition >= btnContainerDocumentOffset && !body.classList.contains('sticky-form-actions')) {
            body.classList.add('sticky-form-actions');
          }

          if (scrollPosition < btnContainerDocumentOffset && body.classList.contains('sticky-form-actions')) {
            body.classList.remove('sticky-form-actions');
          }
        });
      }

      initShippingCalculator(product) {
        this.shippingCalculatorForm = this.querySelector('#shipping-calculator-form');
        if (!this.shippingCalculatorForm) return
        this.postcodeInput = this.shippingCalculatorForm.querySelector('input[name="postcode"]');
        const userPostcode = userLocation.getStoredLocation().postcode;
        this.postcodeInput.value = userPostcode;
        this.postcodeOptions = this.shippingCalculatorForm.querySelector('ul.postcode-options');
        this.shippingCalculatorForm.addEventListener('submit', (event) => {
          event.preventDefault();
        });
        this.postcodeInput.addEventListener('input', debounce(this.handlePostcodeInput.bind(this), 300));
        this.postcodeInput.addEventListener('focus', this.handlePostcodeInput.bind(this));
        this.postcodeOptions.addEventListener('click', this.handlePostcodeSelect.bind(this));
        document.addEventListener('click', this.handleOutsideClick.bind(this));
        this.updateSuburbState();
        this.querySelector('.shipping-calculator').classList.remove('hidden');
      }

      handlePostcodeInput(event) {
        const postcode = event.target.value;
        this.postcodeOptions.innerHTML = '';
        if (postcode.length < 3) return;

        // Fetch Postcodes from API
        this.fetchPostcodes(postcode).then((postcodes) => {
          postcodes.forEach((location) => {
            const locationPostcode = location[0];
            const locationSuburb = location[1];
            const locationState = location[2];
            const option = document.createElement('li');
            option.dataset.postcode = locationPostcode;
            option.dataset.suburb = locationSuburb;
            option.dataset.state = locationState;
            option.textContent = `${locationPostcode} ${locationSuburb
              } ${locationState}`;
            this.postcodeOptions.appendChild(option);
          });
        });
      }

      handlePostcodeSelect(event) {
        const selectedSuburb = event.target.dataset.suburb;
        const selectedPostcode = event.target.dataset.postcode;
        const selectedState = event.target.dataset.state;

        userLocation.setLocationSelected();
        userLocation.setStoredLocation(selectedSuburb, selectedState, selectedPostcode);
        this.postcodeOptions.innerHTML = '';
        this.updateSuburbState();
        // Close Postcode Collapsible
        const postcodeCollapsible = this.querySelector('.shipping-calculator__postcode-input-collapsible');
        postcodeCollapsible.collapse();
        this.displayPromiseDates();
      }

      async fetchPostcodes(postcode) {
        const formData = new URLSearchParams();
        formData.append('postcode', postcode);
        const postcodes = await this.apiWebServer.post('/shopify/findPostcodes.php', formData).then((response) => {
          if (response.success) {
            return response.data;
          } else {
            console.error('Error fetching postcodes', response);
          }
        }).catch((error) => {
          console.error('Error fetching postcodes', error);
        });

        return postcodes;
      }

      async fetchShippingQuotes() {
        const location = userLocation.getStoredLocation();
        const origin = {
          country: "AU",
          postal_code: "2164",
          province: "NSW",
          city: "Wetherill Park",
          name: null,
          address1: "Unit 2, 6-8 Newton Road",
          address2: "",
          address3: null,
          phone: null,
          fax: null,
          email: "info@luxoliving.com.au",
          address_type: null,
          company_name: "Luxo Living"
        }

        const destination = {
          country: "AU",
          postal_code: location.postcode,
          province: location.state,
          city: location.suburb,
          name: null,
          address1: null,
          address2: null,
          address3: null,
          phone: null,
          fax: null,
          email: "",
          address_type: null,
          company_name: null
        };

        const productSku = this.selectedVariant.sku;
        // const productQty = parseInt(this.quantityInput.value);
        const productQty = 1;

        // Check if product contains tag 'bundle' to identify if its a bundle product
        let items = [];

        if (this.bundledProducts && this.bundledProducts.length > 0) {
          this.bundledProducts.forEach((bundledProduct) => {
            items.push({
              sku: bundledProduct.sku,
              quantity: productQty
            });
          });
        } else {
          items = [{
            sku: productSku,
            quantity: productQty
          }];
        }

        const request = {
          rate: {
            origin: origin,
            destination: destination,
            items: items,
            currency: 'AUD',
            locale: "en"
          }
        };

        const carrierQuotes = await this.laravelApiWebServer.post('/api/siss-shopify-ep/rate', JSON.stringify(request)).then((response) => {
          if (response.success) {
            const data = response.data;
            const carrierQuotes = data.rates;
            return carrierQuotes;
          } else {
            console.error('Error fetching promise dates', response);
          }
        }).catch((error) => {
          console.error('Error fetching promise dates', error);
        });

        return carrierQuotes;
      }

      async displayPromiseDates() {
        const promiseDateResults = this.querySelector('.shipping-calculator__results');
        if (!promiseDateResults) return;
        promiseDateResults.innerHTML = '';
        const shippingQuotes = await this.fetchShippingQuotes();
        let promiseDatesHTML = `<ul class="shipping-calculator__shipping-options-list">`;
        // Cutoff comes from the "Christmas delivery" theme setting (YYYY-MM-DD); element only renders when set
        const arrivesBeforeChristmasMessageEl = this.querySelector('[data-arrives-before-christmas-message]');
        const christmasCutoff = /^\d{4}-\d{2}-\d{2}$/.test(arrivesBeforeChristmasMessageEl?.dataset.cutoff || '')
          ? arrivesBeforeChristmasMessageEl.dataset.cutoff
          : '';
        let arrivesBeforeChristmas = false;
        if (shippingQuotes && shippingQuotes.length > 0) {
          let warehouseLocation = '';
          shippingQuotes.forEach((quote) => {
            const shippingCode = quote.service_code;
            const isClickAndCollect = shippingCode === 'siss_cnc';

            const additionalDetails = quote.metafields.find((field) => field.namespace === 'shipping' && field.key === 'additional_details')?.value || '';
            const productShippingInformation = additionalDetails.split('||')[0].split(':');

            const promiseDate = quote.metafields.find((field) => field.namespace === 'shipping' && field.key === 'promised_date')?.value || '';
            const totalPrice = quote.total_price / 100;
            let quotePrice = '';
            if (totalPrice === 0 || totalPrice > 0) {
              quotePrice = totalPrice.toFixed(2).replace(/\.00$/, '');
            }
            let formattedDay = '';
            let formattedMonth = '';
            let formattedOrdinalDate = '';
            let formattedYear = '';

            if (promiseDate.split('-').length == 3) {
              const promiseDateObj = new Date(promiseDate);
              formattedDay = getDayLong(promiseDateObj);
              formattedMonth = getMonthLong(promiseDateObj);
              formattedOrdinalDate = promiseDateObj.getDate().toString();
              formattedYear = getPromiseDateYearSuffix(promiseDateObj);

              // YYYY-MM-DD strings compare correctly as plain strings, avoiding UTC/local parsing offsets
              if (christmasCutoff && promiseDate.slice(0, 10) <= christmasCutoff) {
                arrivesBeforeChristmas = true;
              }
            }

            if (isClickAndCollect) {
              // Click & Collect
              const productWarehouseLocation = productShippingInformation[1];
              warehouseLocation = productWarehouseLocation;
              const cncIcon = document.getElementById('svg-icon-shopping') ? document.getElementById('svg-icon-shopping').innerHTML : '';

              promiseDatesHTML += `<li class="shipping-calculator__shipping-option">
                <span class="shipping-calculator__shipping-option-date"><span class="shipping-calculator__shipping-option-date__icon">${cncIcon} </span><span class="promise-date">Click and Collect from <span class="highlight-date">${formattedDay} ${formattedOrdinalDate} ${formattedMonth}${formattedYear}</span></span></span>
              </li>`;
            } else {
              // Promise Date
              const productWarehouseLocation = productShippingInformation[1];
              warehouseLocation = productWarehouseLocation;
              if (promiseDate.split('-').length == 3) {
                const truckIcon = document.getElementById('svg-icon-truck') ? document.getElementById('svg-icon-truck').innerHTML : '';
                const formattedShippingCost = quotePrice == 0 ? 'FREE' : `$${quotePrice}`;
                let urgencyMessage = ''

                if (formattedDay === 'today' || formattedDay === 'tomorrow')
                  urgencyMessage = this.getUrgencyMessageHtml();
                promiseDatesHTML += `<li class="shipping-calculator__shipping-option get-it-by-option">
                  <span class="shipping-calculator__shipping-option-date"><span class="shipping-calculator__shipping-option-date__icon">${truckIcon} </span><span class="promise-date">Get it by <span class="highlight-date">${formattedDay} ${formattedOrdinalDate} ${formattedMonth}${formattedYear}</span> for ${formattedShippingCost}${urgencyMessage || ''}</span></span>
                </li>`;
              } else {
                const truckIcon = document.getElementById('svg-icon-truck') ? document.getElementById('svg-icon-truck').innerHTML : '';
                const formattedShippingCost = quotePrice == 0 ? 'FREE' : `$${quotePrice}`;
                promiseDatesHTML += `<li class="shipping-calculator__shipping-option">
                  <span class="shipping-calculator__shipping-option-date"><span class="shipping-calculator__shipping-option-date__icon">${truckIcon} </span><span class="promise-date">Get it delivered for ${formattedShippingCost}</span></span>
                </li>`;
              }

            }
          });
          if (warehouseLocation) {
            // Show Stock Status for Warehouse Location
            this.displayStockStatus(warehouseLocation);
            this.product.warehouseLocation = warehouseLocation;
          }
        } else {
          // Display Shipping Unavailable
          promiseDatesHTML = `<div class="shipping-calculator__promise-dates
          shipping-calculator__promise-dates--unavailable">Shipping options currently unavailable</div>`;
        }
        if (arrivesBeforeChristmasMessageEl) {
          arrivesBeforeChristmasMessageEl.style.display = arrivesBeforeChristmas ? 'flex' : 'none';
        }
        promiseDateResults.innerHTML = promiseDatesHTML;
      }

      displayStockStatus(warehouseLocation) {
        const stockStatusDisplayAll = document.querySelectorAll('.stock-status__display');
        if (!stockStatusDisplayAll) return;

        stockStatusDisplayAll.forEach((stockStatusDisplay) => {
          stockStatusDisplay.innerHTML = '';

          let productInventory = 0;
          let productIsPreorder = false;
          if (this.usingVariantSelectors) {
            productInventory = this.selectedVariant.inventory_quantity || 0;
            if (this.selectedVariant.available == false) {
              productInventory = 0;
              productIsPreorder = false;
            } else {
              if (warehouseLocation === 'WP') {
                productInventory = this.selectedVariant.metafields.inventory_sydney_warehouse || productInventory;
                productIsPreorder = this.selectedVariant.metafields.preorder_sydney_warehouse || false;
              } else if (warehouseLocation === 'BNE') {
                productInventory = this.selectedVariant.metafields.inventory_brisbane_warehouse || productInventory;
                productIsPreorder = this.selectedVariant.metafields.preorder_brisbane_warehouse || false;
              } else if (warehouseLocation === 'PER') {
                productInventory = this.selectedVariant.metafields.inventory_perth_warehouse || productInventory;
                productIsPreorder = this.selectedVariant.metafields.preorder_perth_warehouse || false;
              } else {
                // Sydney Default
                productInventory = this.selectedVariant.metafields.inventory_sydney_warehouse || productInventory;
                productIsPreorder = this.selectedVariant.metafields.preorder_sydney_warehouse || false;
              }
            }
          } else {
            if (warehouseLocation === 'WP') {
              productInventory = this.product.metafields.inventory_sydney_warehouse || 0;
              productIsPreorder = this.product.metafields.preorder_sydney_warehouse || false;
            } else if (warehouseLocation === 'BNE') {
              productInventory = this.product.metafields.inventory_brisbane_warehouse || 0;
              productIsPreorder = this.product.metafields.preorder_brisbane_warehouse || false;
            } else if (warehouseLocation === 'PER') {
              productInventory = this.product.metafields.inventory_perth_warehouse || 0;
              productIsPreorder = this.product.metafields.preorder_perth_warehouse || false;
            } else {
              // Sydney Default
              productInventory = this.product.metafields.inventory_sydney_warehouse || 0;
              productIsPreorder = this.product.metafields.preorder_sydney_warehouse || false;
            }
          }

          let stockStatusHTML = '';
          const tickIcon = document.getElementById('svg-icon-checkmark')?.innerHTML || '';
          const alertIcon = document.getElementById('svg-icon-alert') ? document.getElementById('svg-icon-alert').innerHTML : '';
          // If using variant selectors, wont use this as its getting handled somewhere else
          if (!this.usingVariantSelectors) {
            if (productInventory > 0) {
              // Enable Add To Cart Button
              this.addToCartButton.disabled = false;
              this.addToCartButton.querySelector('span').textContent = this.translations.add_to_cart;
              if (this.buyNowButton) {
                this.buyNowButton.disabled = false;
                this.buyNowButton.classList.remove('hidden');
              }
              // Remove Sold Out Badge
              this.product.available = true;
            } else {
              // Disable Add To Cart Button
              this.addToCartButton.disabled = true;
              this.addToCartButton.querySelector('span').textContent = this.translations.sold_out;
              if (this.buyNowButton) {
                this.buyNowButton.disabled = true;
                this.buyNowButton.classList.add('hidden');
              }
              // Show Sold Out Badge
              this.product.available = false;
            }
          }
          this.updateProductBadges(this.product);
          if (productIsPreorder && productInventory > 0) {
            // Preorder Available
            const preOrderIcon = document.getElementById('svg-icon-preorder') ? document.getElementById('svg-icon-preorder').innerHTML : '';
            stockStatusHTML = `<span class="stock-status__preorder" data-stock-status="preorder">
            ${preOrderIcon} ${this.translations.stock_status.preorder_available}
          </span>`;
          } else if ((productIsPreorder == false) && productInventory > 0 && productInventory <= this.settings.low_stock_threshold) {
            // In Stock
            stockStatusHTML = `<span class="stock-status__low-stock" data-stock-status="low-stock">
            ${alertIcon} ${this.translations.stock_status.low_stock}. <strong>Only ${productInventory} left!</strong>
          </span>`;
          } else if ((productIsPreorder == false) && productInventory > 0) {
            // In Stock
            stockStatusHTML = `<span class="stock-status__in-stock" data-stock-status="in-stock">
            ${tickIcon} ${this.translations.stock_status.in_stock}
          </span>`;
          } else if (productInventory == 0) {
            // Out of Stock
            stockStatusHTML = `<span class="stock-status__sold-out" data-stock-status="sold-out">
            ${this.translations.stock_status.sold_out}
          </span>`;
          }

          stockStatusDisplay.innerHTML = stockStatusHTML;
        });
      }

      updateSuburbState() {
        const suburbState = this.querySelector('[data-suburb-state]');
        if (suburbState) {
          const location = userLocation.getStoredLocation();
          const capitalizedSuburb = capitalizeWords(location.suburb);
          suburbState.innerHTML = `<span class="shipping-calculator__selected-suburb">${capitalizedSuburb}</span>, <span class="shipping-calculator__selected-state">${location.state}</span>`;
        }
      }

      handleOutsideClick(event) {
        // Check if the click was outside the input field and the postcode options list
        const isClickInsideInput = event.target === this.postcodeInput;
        const isClickInsideOptions = this.postcodeOptions.contains(event.target);

        if (!isClickInsideInput && !isClickInsideOptions) {
          this.postcodeOptions.innerHTML = ''; // Clear the suggestions list

          // Remove the event listener after clearing to avoid redundant listeners
          document.removeEventListener('click', this.handleOutsideClick.bind(this));
        }
      }

      updateProductQtyInCart(quantity) {
        const selectedProductQtyInCart = quantity ? quantity : 0;
        const productAddedToCart = this.querySelector('.product__added-to-cart');
        if (!productAddedToCart) return;

        const stickyMedia = productAddedToCart.closest('.product__sticky-media');
        if (stickyMedia) {
          stickyMedia.classList.toggle('product__sticky-media--has-cart', Number(selectedProductQtyInCart) > 0);
        }

        productAddedToCart.innerHTML = '';

        if (Number(selectedProductQtyInCart) > 0) {
          const addedToCartHTML = `<div class="product__added-to-cart-icon">
            <div class="in-cart-icon">
              <div class="in-cart-icon-qty">${selectedProductQtyInCart}</div>
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_39_12)"><path d="M20.9813 5.45777C20.8463 5.92732 20.7053 6.39564 20.5783 6.86702C19.9964 9.0273 19.42 11.1894 18.8393 13.3497C18.5743 14.3364 17.8532 14.8896 16.8365 14.8902C13.7549 14.8908 10.6732 14.8908 7.59152 14.889C7.42239 14.889 7.25264 14.8695 7.05298 14.8573C7.1635 15.2657 7.27218 15.6675 7.38514 16.0852C7.48162 16.0852 7.56954 16.0852 7.65686 16.0852C10.7318 16.0852 13.8068 16.0833 16.8817 16.0864C18.1817 16.0876 19.2179 17.1562 19.1727 18.4372C19.1397 19.3702 18.5279 20.1963 17.6474 20.4967C16.77 20.7965 15.8065 20.5303 15.1934 19.8177C14.5975 19.1253 14.4919 18.1038 14.9315 17.2874C14.9663 17.2227 15.0017 17.1592 15.0475 17.0756H9.3482C9.38179 17.1397 9.41232 17.1971 9.44223 17.2551C9.88064 18.1136 9.84584 18.9531 9.26333 19.7213C8.6912 20.4753 7.90048 20.7635 6.97604 20.5517C6.02596 20.3343 5.45017 19.7084 5.25417 18.7565C5.07343 17.8779 5.47459 16.9693 6.24638 16.4729C6.38194 16.3856 6.40025 16.3117 6.35934 16.1621C5.39033 12.6365 4.42376 9.11034 3.46512 5.58233C3.10243 4.24635 2.7605 2.90487 2.40941 1.56584C2.39231 1.5005 2.37277 1.43578 2.35079 1.35885H0V0.380063H0.189895C0.99649 0.380063 1.80248 0.379452 2.60907 0.380063C2.99497 0.380063 3.13052 0.486306 3.2331 0.862432C3.57137 2.10621 3.90903 3.35061 4.2473 4.595C4.265 4.66033 4.28393 4.72505 4.30774 4.80871H4.57152C9.81958 4.80871 15.067 4.80993 20.3151 4.80504C20.6173 4.80504 20.8481 4.88564 20.9806 5.17018V5.45716L20.9813 5.45777ZM4.54832 5.80458C4.56481 5.87725 4.5758 5.93708 4.59167 5.99509C5.24684 8.3758 5.90201 10.7559 6.55718 13.1366C6.71349 13.7051 7.04626 13.956 7.64587 13.956C10.6933 13.956 13.7402 13.956 16.7877 13.956C17.4233 13.956 17.739 13.71 17.9032 13.0933C18.4045 11.2083 18.9077 9.32344 19.409 7.43793C19.5525 6.89877 19.6941 6.35962 19.8407 5.80458H4.54832ZM16.9129 19.6535C17.6376 19.6565 18.2214 19.0765 18.2183 18.3566C18.2153 17.6465 17.6346 17.0652 16.9257 17.0627C16.207 17.0603 15.6166 17.6483 15.619 18.3633C15.6221 19.0759 16.1979 19.6498 16.9123 19.6529L16.9129 19.6535ZM7.4633 19.6535C8.18868 19.6553 8.76386 19.0807 8.76264 18.356C8.76142 17.644 8.18502 17.0646 7.47551 17.0633C6.76356 17.0615 6.18166 17.6355 6.17616 18.345C6.17067 19.074 6.73974 19.6523 7.46269 19.6541L7.4633 19.6535Z" fill="black"></path></g><defs><clipPath id="clip0_39_12"><rect width="20.9813" height="20.24" fill="white" transform="translate(0 0.380005)"></rect></clipPath></defs>
              </svg>
            </div>
          </div>`;
          productAddedToCart.innerHTML = addedToCartHTML;
        }
      }

      getTimeRemainingFromCutOff(cutoffDate) {
        const nowSydney = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
        const diffMs = cutoffDate - nowSydney;
        const hours = Math.floor(diffMs / (1000 * 60 * 60));
        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        return { hours, minutes, formatted: hours > 0 ? `${hours} hrs and ${minutes} min` : `${minutes} min` };
      }
      shouldShowUrgencyMessage() {
        const shipDayEl = document.querySelector('.shipping-calculator__results .highlight-date');
        return shipDayEl.textContent.includes('today') || shipDayEl.textContent.includes('tomorrow');
      }

      getUrgencyMessageHtml() {
        const nowSydney = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
        const cutoff = new Date(nowSydney);// Cut-off time: 11:30am Sydney
        cutoff.setHours(11, 30, 0, 0);
        if (nowSydney > cutoff) {
          cutoff.setDate(cutoff.getDate() + 1);
          const hoursDiff = Math.ceil((cutoff - nowSydney) / 3600000);
          if (hoursDiff >= 18)
            return
        }
        const minutesLeftToOrder = this.getTimeRemainingFromCutOff(cutoff)
        const urgencyTriggerHTML = `
          <span class="urgency-trigger scroll-trigger animate--slide-in">- Order within ${minutesLeftToOrder.formatted}</span>`;
        return urgencyTriggerHTML;
      }

      updateProductBadges(product) {
        // Find the corresponding badge
        const productBadges = this.querySelector('.product__badges');
        productBadges.innerHTML = '';

        if (productBadges) {
          if (this.selectedVariant.available === false) {
            // this.updateSoldOutBadge(productBadges);
          } else {
            if (this.settings.show_new_badge)
              this.updateNewBadge(productBadges, product);
            if (this.isProductOnSale(product) || this.activeCouponPromo) {
              try {
                const countdown = this.getCountdown(product);
                if (countdown.countdownActive && this.settings.show_countdown_sale_badge) {
                  this.updateCountdownSaleBadge(productBadges, product, countdown);
                }
              } catch (error) { console.error('Error getting countdown data:', error); }
              // else {
              this.updateSalesBadge(productBadges, product);
              // }
              this.mountPreorderSaleBadge()
            }
            if (this.settings.show_preorder_badge)
              this.updatePreorderBadge(productBadges, product);
            if (this.settings.show_low_stock_badge)
              this.updateLowStockBadge(productBadges, product);
            if (this.settings.show_clearance_badge)
              this.updateClearanceBadge(productBadges, product);
            // this.updateLuxoLiveBadge(productBadges, product);
          }
        }
      }

      updateClearanceBadge(productBadges, product) {
        const clearanceBadgeText = this.translations.clearance;
        const clearanceBadgeColor = this.settings.clearance_badge_color_scheme;

        const searchTerm = 'clearance';
        const isClearanceItem = product.tags.some(tag => tag.toLowerCase() === searchTerm.toLowerCase());

        // Check product tags for clearance
        if (isClearanceItem) {
          // Add the badge
          if (!productBadges.querySelector('[data-clearance-badge]')) {
            // Create the badge
            const clearanceBadge = document.createElement('span');
            // clearanceBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            clearanceBadge.classList.add('badge', `badge--top-left`, `color-${clearanceBadgeColor}`);
            clearanceBadge.dataset.clearanceBadge = '';
            clearanceBadge.textContent = clearanceBadgeText;

            productBadges.appendChild(clearanceBadge);
          }
        } else {
          // Remove the badge
          if (productBadges.querySelector('[data-clearance-badge]')) {
            productBadges.querySelector('[data-clearance-badge]').remove();
          }
        }
      }

      updateLuxoLiveBadge(productBadges, product) {
        const luxoLiveHTML = this.translations.luxo_live_html;

        const searchTerm = 'luxo live';
        const isLuxoLiveItem = product.tags.some(tag => tag.toLowerCase() === searchTerm.toLowerCase());

        // Check product tags for clearance
        if (isLuxoLiveItem) {
          // Add the badge
          if (!productBadges.querySelector('[data-luxo-live-badge]')) {
            // Create the badge
            const luxoLiveBadge = document.createElement('span');
            // clearanceBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            luxoLiveBadge.classList.add('badge', `badge--top-left`, `color-luxo-live`, `luxo-live-badge`);
            luxoLiveBadge.dataset.luxoLiveBadge = '';

            luxoLiveBadge.innerHTML = luxoLiveHTML;

            productBadges.appendChild(luxoLiveBadge);
          }
        } else {
          // Remove the badge
          if (productBadges.querySelector('[data-luxo-live-badge]')) {
            productBadges.querySelector('[data-luxo-live-badge]').remove();
          }
        }
      }

      updateLowStockBadge(productBadges, product) {
        const productWarehouseLocation = product.warehouseLocation;
        const lowStockBadgeText = this.translations.low_stock;
        const lowStockBadgeColor = this.settings.low_stock_badge_color_scheme;
        const lowStockThreshold = parseInt(this.settings.low_stock_threshold);

        let inventoryQuantity = 0;

        if (this.usingVariantSelectors) {
          // Get products inventory quantity based on the warehouse location
          // Warehouse location will be determined by the users selected location and retrieved from the shipping calculator
          if (productWarehouseLocation == 'BNE') {
            inventoryQuantity = this.selectedVariant.metafields.inventory_brisbane_warehouse;
          } else if (productWarehouseLocation == 'PER') {
            inventoryQuantity = this.selectedVariant.metafields.inventory_perth_warehouse;
          } else {
            // Use Wetherill Park as the default warehouse location
            inventoryQuantity = this.selectedVariant.metafields.inventory_sydney_warehouse;
          }
        } else {
          // Get products inventory quantity based on the warehouse location
          // Warehouse location will be determined by the users selected location and retrieved from the shipping calculator
          if (productWarehouseLocation == 'BNE') {
            inventoryQuantity = product.metafields.inventory_brisbane_warehouse;
          } else if (productWarehouseLocation == 'PER') {
            inventoryQuantity = product.metafields.inventory_perth_warehouse;
          } else {
            // Use Wetherill Park as the default warehouse location
            inventoryQuantity = product.metafields.inventory_sydney_warehouse;
          }
        }

        if (inventoryQuantity <= lowStockThreshold) {
          // Add the badge
          if (!productBadges.querySelector('[data-low-stock-badge]')) {
            // Create the badge
            const lowStockBadge = document.createElement('span');
            // lowStockBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            lowStockBadge.classList.add('badge', `badge--top-right`, `color-${lowStockBadgeColor}`);
            lowStockBadge.dataset.lowStockBadge = '';
            lowStockBadge.textContent = lowStockBadgeText;

            productBadges.appendChild(lowStockBadge);
          }
        } else {
          // Remove the badge
          if (productBadges.querySelector('[data-low-stock-badge]')) {
            productBadges.querySelector('[data-low-stock-badge]').remove();
          }
        }
      }

      updateSoldOutBadge(productBadges) {
        const soldOutBadgeText = this.translations.sold_out;
        const soldOutBadgeColor = this.settings.sold_out_badge_color_scheme;

        if (this.selectedVariant.available === false) {
          // Add the badge
          if (!productBadges.querySelector('[data-sold-out-badge]')) {
            // Create the badge
            const soldOutBadge = document.createElement('span');
            // soldOutBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            soldOutBadge.classList.add('badge', `badge--top-left`, `color-${soldOutBadgeColor}`);
            soldOutBadge.dataset.soldOutBadge = '';
            soldOutBadge.textContent = soldOutBadgeText;

            productBadges.appendChild(soldOutBadge);
          }
        } else {
          // Remove the badge
          if (productBadges.querySelector('[data-sold-out-badge]')) {
            productBadges.querySelector('[data-sold-out-badge]').remove();
          }
        }
      }

      updatePreorderBadge(productBadges, product) {
        const preorderBadgeText = this.translations.preorder;
        const preorderBadgeColor = this.settings.preorder_badge_color_scheme;

        const productWarehouseLocation = 'WP';
        let productIsPreorder = false;

        // Get products preorder status based on the warehouse location
        // Warehouse location will be determined by the users selected location and retrieved from the shipping calculator
        if (this.usingVariantSelectors) {
          if (productWarehouseLocation == 'BNE') {
            productIsPreorder = this.selectedVariant.metafields.preorder_brisbane_warehouse;
          } else if (productWarehouseLocation == 'PER') {
            productIsPreorder = this.selectedVariant.metafields.preorder_perth_warehouse;
          } else {
            // Use Wetherill Park as the default warehouse location
            productIsPreorder = this.selectedVariant.metafields.preorder_sydney_warehouse;
          }
        } else {
          if (productWarehouseLocation == 'BNE') {
            productIsPreorder = product.metafields.preorder_brisbane_warehouse;
          } else if (productWarehouseLocation == 'PER') {
            productIsPreorder = product.metafields.preorder_perth_warehouse;
          } else {
            // Use Wetherill Park as the default warehouse location
            productIsPreorder = product.metafields.preorder_sydney_warehouse;
          }
        }

        if (productIsPreorder) {
          // Add the badge
          if (!productBadges.querySelector('[data-preorder-badge]')) {
            // Create the badge
            const preorderBadge = document.createElement('span');
            // preorderBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            preorderBadge.classList.add('badge', `badge--top-right`, `color-${preorderBadgeColor}`);
            preorderBadge.dataset.preorderBadge = '';
            preorderBadge.textContent = preorderBadgeText;

            productBadges.appendChild(preorderBadge);
          }
        } else {
          // Remove the badge
          if (productBadges.querySelector('[data-preorder-badge]')) {
            productBadges.querySelector('[data-preorder-badge]').remove();
          }
        }
      }
      isProductNew(product) {
        if (product)
          return product.tags.some(tag => tag.toLowerCase() === 'new furniture');
        return false
      }
      updateNewBadge(productBadges, product) {
        const newBadgeText = this.translations.new;
        // Check if Product is New
        if (this.isProductNew(product)) {
          // Add the badge
          if (!productBadges.querySelector('[data-new-badge]')) {
            // Create the badge
            const newBadge = document.createElement('span');
            // newBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            newBadge.classList.add('badge', `badge--top-left`, `color-${this.settings.new_badge_color_scheme}`);
            newBadge.dataset.newBadge = '';
            newBadge.textContent = newBadgeText;

            productBadges.appendChild(newBadge);
          }
        } else {
          // Remove the badge
          if (productBadges.querySelector('[data-new-badge]')) {
            productBadges.querySelector('[data-new-badge]').remove();
          }
        }
      }
      isPreorderSale() {
        return this.product.metafields && this.product.metafields.preorder_discount && this.product.metafields.preorder_discount;
      }

      mountPreorderSaleBadge() {
        if (!this.isPreorderSale()) return;
        const preorderBadgeText = this.translations.early_bird_sale;
        // Create the badge
        const preorderBadge = document.createElement('span');
        preorderBadge.textContent = preorderBadgeText;
        preorderBadge.classList.add('badge-text_off')
        const badgeWrapper = document.createElement('div')
        badgeWrapper.classList.add('badge', 'early-bird-tag', 'scroll-trigger', 'animate--fade-in');
        badgeWrapper.appendChild(preorderBadge)
        this.querySelector('.product__badges').appendChild(badgeWrapper);
      }

      getCountdown(product) {
        let countdownActive = false;
        let timeLeft = {
          daysLeft: 0,
          hoursLeft: 0,
          minutesLeft: 0,
          message: ''
        }

        const todayTimestamp = Math.floor(Date.now() / 1000); // Current time in Unix timestamp (seconds)
        let productSaleStartTimestamp = 0;
        let productSaleEndTimestamp = 0;
        if (this.usingVariantSelectors) {
          if ((!this.selectedVariant.metafields.sale_start_date_time || !this.selectedVariant.metafields.sale_end_date_time) && !this.activeCouponPromo) return { countdownActive, timeLeft };
          const endDate = this.selectedVariant.metafields.sale_end_date_time || this.activeCouponPromo?.end_date;
          const startDate = this.selectedVariant.metafields.sale_start_date_time || this.activeCouponPromo?.start_date;
          productSaleStartTimestamp = Math.floor(new Date(startDate).getTime() / 1000); // Product creation time in Unix timestamp (seconds)
          productSaleEndTimestamp = Math.floor(new Date(endDate).getTime() / 1000); // Product creation time in Unix timestamp (seconds)

          productSaleEndTimestamp = getDayDifference(SYDNEY_DATE_NOW, new Date(endDate)) > 7 ?
            getDateBlocks(SYDNEY_DATE_NOW, endDate, 7).find((block) => block.end > SYDNEY_DATE_NOW && block.start <= SYDNEY_DATE_NOW).end.getTime() / 1000
            : productSaleEndTimestamp
        } else {
          if ((!product.metafields.sale_start_date_time || !product.metafields.sale_end_date_time) && !this.activeCouponPromo) return { countdownActive, timeLeft };
          const endDate = product.metafields.sale_end_date_time || this.activeCouponPromo?.end_date;
          const startDate = product.metafields.sale_start_date_time || this.activeCouponPromo?.start_date;
          productSaleStartTimestamp = Math.floor(new Date(startDate).getTime() / 1000); // Product creation time in Unix timestamp (seconds)
          productSaleEndTimestamp = Math.floor(new Date(endDate).getTime() / 1000); // Product creation time in Unix timestamp (seconds)
          productSaleEndTimestamp = getDayDifference(SYDNEY_DATE_NOW, new Date(endDate)) > 7 ?
            getDateBlocks(SYDNEY_DATE_NOW, endDate, 7).find((block) => block.end > SYDNEY_DATE_NOW && block.start <= SYDNEY_DATE_NOW).end.getTime() / 1000
            : productSaleEndTimestamp
        }
        if (todayTimestamp >= productSaleStartTimestamp && todayTimestamp <= productSaleEndTimestamp) {
          countdownActive = true;
          // Get days, hours, minutes left in sale
          const daysLeft = Math.floor((productSaleEndTimestamp - todayTimestamp) / 86400);
          const hoursLeft = Math.floor((productSaleEndTimestamp - todayTimestamp) / 3600);
          const minutesLeft = Math.floor((productSaleEndTimestamp - todayTimestamp) / 60) % 60;
          let remainingTimeLeftMessage = "";

          // Get Time Left
          if (daysLeft > 0) {
            remainingTimeLeftMessage = `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left`;
          } else if (hoursLeft > 0) {
            remainingTimeLeftMessage = `${hoursLeft} ${hoursLeft === 1 ? 'hour' : 'hours'} left`;
          } else if (minutesLeft > 0) {
            remainingTimeLeftMessage = `${minutesLeft} ${minutesLeft === 1 ? 'minute' : 'minutes'} left`;
          }

          timeLeft = {
            daysLeft,
            hoursLeft,
            minutesLeft,
            message: remainingTimeLeftMessage
          };
        }

        return {
          countdownActive,
          timeLeft
        }
      }

      updateCountdownSaleBadge(productBadges, product, countdown) {
        const onSaleBadgeText = this.translations.on_sale;
        const countdownSaleBadgeColor = this.settings.countdown_sale_badge_color_scheme;
        const couponBadge = this.querySelector('coupon-badge');
        const couponDiscount = couponBadge ? couponBadge.dataset.isPercent == 'true' ? (product.price * +couponBadge.dataset.discount) / 100 : +couponBadge.dataset.discount * 100 : 0;
        const compare_at_price = !!product.compare_at_price ? product.compare_at_price : product.price;
        const salePrice = product.price - couponDiscount;
        // Is product in sale period
        if (countdown.countdownActive) {
          if (!productBadges.querySelector('[data-countdown-sale-badge]')) {
            // Create the badge
            const countdownSaleBadge = document.createElement('span');
            // countdownSaleBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            countdownSaleBadge.classList.add('badge', 'scroll-trigger', 'animate--fade-in', `badge--bottom-right`, `color-${countdownSaleBadgeColor}`, `badge--promo-${this.settings.promotion_badge_design_scheme}`);
            countdownSaleBadge.dataset.countdownSaleBadge = '';
            let countdownSalesBadgeHtml = `<div class="sales-badge-countdown">
                <div class="badge-text">`;
            if (this.settings.promotion_badge_off_value == 'dollar_off') {
              const dollarOffValue = compare_at_price - salePrice;
              const formattedDollarOffValue = (dollarOffValue / 100).toFixed(2).replace('.00', '');
              countdownSalesBadgeHtml += `<span class="badge-text__off">$${formattedDollarOffValue} Off</span>`;
            } else if (this.settings.promotion_badge_off_value == 'percent_off') {
              const percentageOffValue = Math.floor((compare_at_price - salePrice) / compare_at_price * 100);
              countdownSalesBadgeHtml += `<span class="badge-text__off">${percentageOffValue}% Off</span>`;
            } else {
              countdownSalesBadgeHtml += `<span class="badge-text__off">${onSaleBadgeText}</span>`;
            }
            if (this.settings.promotion_badge_design_scheme == 'christmas') {
              countdownSalesBadgeHtml += `<span class="badge-message">Xmas Sale</span>`;
            } else if (this.settings.promotion_badge_design_scheme == 'black-friday') {
              countdownSalesBadgeHtml += `<span class="badge-message">Black Friday</span>`;
            } else if (this.settings.promotion_badge_design_scheme == 'cyber-week') {
              countdownSalesBadgeHtml += `<span class="badge-message">Cyber Week</span>`;
            }

            countdownSaleBadge.innerHTML = countdownSalesBadgeHtml;

            productBadges.appendChild(countdownSaleBadge);
          }
        } else {
          // Remove the badge
          if (productBadges.querySelector('[data-countdown-sale-badge]')) {
            productBadges.querySelector('[data-countdown-sale-badge]').remove();
          }
        }
      }

      isProductOnSale() {
        let comparePrice = this.selectedVariant && this.selectedVariant.compare_at_price ? this.selectedVariant.compare_at_price : null;
        let price = this.selectedVariant && this.selectedVariant.price ? this.selectedVariant.price : null;

        if (comparePrice && price && comparePrice > price) {
          return true;
        }

        return false;
      }

      updateSalesBadge(productBadges, product) {
        if (this.isProductOnSale()) {
          // Add the badge
          if (!productBadges.querySelector('[data-sale-badge]')) {
            // Update the badge text or attributes
            const onSaleBadgeText = this.translations.on_sale;

            // Create the badge
            const onSaleBadge = document.createElement('span');
            // onSaleBadge.id = `NoMediaStandardBadge-${this.sectionId}-${product.id}`;
            onSaleBadge.classList.add('badge', `badge--bottom-left`, `color-${this.settings.sale_badge_color_scheme}`, `badge--promo-${this.settings.promotion_badge_design_scheme}`);
            onSaleBadge.dataset.saleBadge = '';
            onSaleBadge.textContent = onSaleBadgeText;

            productBadges.appendChild(onSaleBadge);
          } else {
            // Remove the badge
            if (productBadges.querySelector('[data-sale-badge]')) {
              productBadges.querySelector('[data-sale-badge]').remove();
            }
          }
        }
      }


      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          const selectedVariant = this.product.variants.find((v) => v.id === variant?.id);

          this.selectedVariant = selectedVariant;
          this.updateProductBadges(this.product);
          this.displayPromiseDates();
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          // this.updateMedia(html, variant?.featured_media?.id);

          // Look at variant SKU, and slide to first image that contains that SKU in the file name
          this.slideToSKUImage(selectedVariant.sku);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Option');

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          const isSubmittable = !(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true
          );

          this.productForm?.toggleSubmitButton(!isSubmittable, window.variantStrings.soldOut);

          this.updateAssemblyService(isSubmittable);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      slideToSKUImage(sku) {
        if (!this.mediaGallery) return;

        // Get first thumbnail slide that contains SKU in the file name
        const thumbnailSlider = this.mediaGallery.querySelector('.thumbnail-slider');
        const foundSlide = thumbnailSlider.querySelector(`[data-media-position] .thumbnail img[src*="${sku}"]`);
        if (!foundSlide) return;
        let slidePosition = foundSlide.closest('[data-media-position]').dataset.mediaPosition;
        slidePosition = parseInt(slidePosition);
        const slideButton = thumbnailSlider.querySelector(`[data-media-position="${slidePosition}"] button`);
        slideButton.click();
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));

        this.updateAssemblyService(false);
      }

      /**
       * Hides and disables the optional in-home assembly service selector when the
       * selected variant cannot be purchased, and restores it when it can.
       * Disabling the inputs removes them from focus order and excludes them from
       * the submitted form data, preventing an assembly line item being added to
       * an unavailable product.
       * @param {boolean} isPurchasable - whether the selected variant is purchasable
       */
      updateAssemblyService(isPurchasable) {
        const assemblyService = this.querySelector('[data-assembly-service]');
        if (!assemblyService) return;

        assemblyService.toggleAttribute('hidden', !isPurchasable);

        assemblyService.querySelectorAll('input').forEach((input) => {
          input.disabled = !isPurchasable;
          if (!isPurchasable && input.type === 'checkbox' && input.checked) {
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
if (!customElements.get('coupon-badge')) {
  customElements.define(
    'coupon-badge',
    class CouponBadge extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.addEventListener('click', this.handleClick.bind(this));
      }
      handleClick() {
        const couponCode = this.dataset.couponCode;
        if (couponCode) {
          navigator.clipboard.writeText(couponCode).then(() => {
            this.querySelector('.mobile-copy-hint').textContent = 'Copied!';
            if (typeof window.luxoPublishEvent === 'function') {
              window.luxoPublishEvent('coupon_code_copied', { coupon_code: couponCode });
            }
          });
        }
      }
    }
  );
}
